<template>
  <div class="m-kpi">
    <div class="m-kpi__label">
      <CygnusIcon v-if="icon" :name="icon" class="m-kpi__icon" />
      <span>{{ label }}</span>
    </div>
    <div class="m-kpi__value">{{ value }}</div>
    <div v-if="delta" class="m-kpi__delta" :class="`is-${deltaDir}`">{{ delta }}</div>
  </div>
</template>

<script>
/**
 * MusubiKpiCard — a single metric tile (label · value · optional delta).
 * Presentational, token-driven. Compose rows of these for dashboards.
 *
 *   <MusubiKpiCard label="Discovered" :value="328" delta="▲ 18%" delta-dir="up" icon="broadcast" />
 */
export default {
  name: 'MusubiKpiCard',
  props: {
    label:    { type: String, required: true },
    value:    { type: [String, Number], required: true },
    /** Optional change text, e.g. "▲ 18%". */
    delta:    { type: String, default: '' },
    /** up | down | neutral — colours the delta. */
    deltaDir: { type: String, default: 'neutral' },
    /** Cygnus icon name, e.g. "broadcast". */
    icon:     { type: String, default: '' },
  },
};
</script>

<style scoped>
.m-kpi {
  background: var(--m-bg-card);
  border: 1px solid var(--m-border);
  border-radius: var(--m-radius-lg);
  padding: var(--m-space-3) var(--m-space-4);
  box-shadow: var(--m-shadow-card);
}
.m-kpi__label {
  display: flex; align-items: center; gap: 7px;
  color: var(--m-text-secondary);
  font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.05em; font-weight: 600;
}
.m-kpi__icon { color: var(--m-accent); }
.m-kpi__value { font-size: var(--m-text-2xl); font-weight: 750; margin-top: 6px; color: var(--m-text-primary); }
.m-kpi__delta { font-size: 0.78rem; margin-top: 3px; color: var(--m-text-tertiary); }
.m-kpi__delta.is-up { color: var(--m-status-success); }
.m-kpi__delta.is-down { color: var(--m-status-danger); }
</style>
